/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { slicedToArray as _slicedToArray } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ResourceTagList from '../../../../Connected/ResourceTagList/ResourceTagList.js';
import ResourceTagModal from '../../../../Connected/ResourceTagModal/ResourceTagModal.js';

var SurfacedDetails = function SurfacedDetails(_ref) {
  var mock = _ref.mock,
    surfacedDetails = _ref.surfacedDetails,
    hasSurfacedDetailsList = _ref.hasSurfacedDetailsList,
    crn = _ref.crn;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    reloadTags = _useState2[0],
    setReloadTags = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    tagModalOpen = _useState4[0],
    setTagModalOpen = _useState4[1];
  var classes = classnames('cpc--page-header__surfaced-details', {
    'cpc--page-header__surfaced-details--list': hasSurfacedDetailsList
  });

  // Event handlers
  var onLoad = useCallback(function () {
    return setReloadTags(false);
  }, []);
  var onIconClick = useCallback(function () {
    return setTagModalOpen(true);
  }, []);
  var onClose = useCallback(function () {
    return setTagModalOpen(false);
  }, []);
  var onSave = useCallback(function () {
    setTagModalOpen(false);
    setReloadTags(true);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, surfacedDetails, crn && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ResourceTagList, {
    mock: mock,
    resourceId: crn,
    reload: reloadTags,
    onLoad: onLoad,
    isEditable: "always",
    onIconClick: onIconClick,
    showAddLabelText: true
  }), /*#__PURE__*/React.createElement(ResourceTagModal, {
    mock: mock,
    resourceId: crn,
    open: tagModalOpen,
    onSave: onSave,
    onClose: onClose
  })));
};
SurfacedDetails.propTypes = {
  /**
   * Details that are surfaced to the end user. These are appended to the end of the title.
   */
  surfacedDetails: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  /**
   * Flag to indicate that the Surfaced Details have a list that should use the common design.
   */
  hasSurfacedDetailsList: PropTypes.bool,
  /**
   * Provide a CRN to automatically show resource tags and allow editing them.
   */
  crn: PropTypes.string,
  /**
   * Whether or not we should use mock data.
   */
  mock: PropTypes.bool
};
var SurfacedDetails$1 = SurfacedDetails;

export { SurfacedDetails$1 as default };
